module.exports = __webpack_public_path__ + "img/zoom.eba74d91.png";